export const splitArrayByPredicate = <Item>(
    items: Item[],
    predicate: (item: Item) => boolean
): [truthyItems: Item[], falsyItems: Item[]] => {
    const truthyItems = [];
    const falsyItems = [];

    for (const item of items) {
        if (predicate(item)) {
            truthyItems.push(item);
        } else {
            falsyItems.push(item);
        }
    }

    return [truthyItems, falsyItems];
};

export function areArraysNotEqual<T>(a: T[], b: T[]): boolean {
    return a.length !== b.length || a.some((v, i) => v !== b[i]);
}

export function areArraysEqual<T>(a: T[], b: T[]): boolean {
    return a.length === b.length && a.every((v, i) => v === b[i]);
}
